import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 771px;
`

export const Section = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
  flex-shrink: 0;
`

export const List = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--color-border-primary);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--color-text-secondary);
  }
`

export const TimeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Label = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin-top: 8px;
  margin-bottom: 4px;
  color: var(--color-text-primary);
`
